module.exports = __webpack_public_path__ + "static/media/team.cbbcc46a.jpg";